'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

var initInstanceCallback = function () {
    var freeTiny = document.querySelector('.tox-notifications-container');
    if (freeTiny) {
        freeTiny.style.display = 'none';
    }
};
var getInitConfig = function (height) {
    return {
        height: height,
        menubar: false,
        // eslint-disable-next-line @typescript-eslint/camelcase
        init_instance_callback: initInstanceCallback,
        plugins: constants.plugins,
        toolbar: constants.toolbar,
    };
};

exports.getInitConfig = getInitConfig;
exports.initInstanceCallback = initInstanceCallback;
